import { SISR_DARK_MODE } from "../utils/access/constants";
import { DARK_MODE_ENUM } from "./constants";

const state = {
  darkMode: false,
};
const mutations = {
  setDarkMode(state, darkMode) {
    state.darkMode = darkMode;
    localStorage.setItem(SISR_DARK_MODE, state.darkMode);
  },
};
const actions = {
  switchDarkMode({ commit }) {
    commit(
      "setDarkMode",
      localStorage.getItem(SISR_DARK_MODE) === DARK_MODE_ENUM.TRUE
        ? DARK_MODE_ENUM.FALSE
        : DARK_MODE_ENUM.TRUE
    );
  },
  makeDarkMode({ commit }) {
    commit(
      "setDarkMode",
      localStorage.getItem(SISR_DARK_MODE) || DARK_MODE_ENUM.FALSE
    );
  },
};
const getters = {};

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations,
};
